





























import cardService from '@/modules/pass/domain/passService'
import Component, { mixins } from 'vue-class-component'
import loading from '@/modules/common/components/loading.vue'
import notificationService from '@/modules/common/services/notificationService'
import page from '@/modules/common/components/page.vue'
import platformService from '@/modules/common/services/platformService'
import { Prop, Watch } from 'vue-property-decorator'
import Pass from '@/modules/pass/domain/pass'
import submitProtectionMixin from '@/modules/common/mixins/submitProtectionMixin'

@Component({
  components: { loading, page }
})
export default class CardPage extends mixins(submitProtectionMixin) {
  companyId?: string | null = null
  pass: Pass | null = null
  initialized = false

  @Prop({ type: String, required: true }) urlName!: string

  get isIphone () {
    return platformService.iphone()
  }

  get linkAvailable () {
    return !!this.pass
  }

  async downloadGoogleCard () {
    this.protect()
    const response = await cardService.downloadGoogleCard(this.pass!.id)
    if (response) {
      window.open(response.fat_pay_pass)
    } else {
      notificationService.error('error.pass.download.failed')
    }
    this.unprotect()
  }

  async downloadAppleCard () {
    this.protect()
    const url = await cardService.getDownloadAppleUrl(this.pass!.id)
    if (url) {
      window.open(url)
    } else {
      notificationService.error('error.pass.download.failed')
    }
    this.unprotect()
  }

  @Watch('urlName')
  async onUrlNameChanged () {
    this.fetchPass()
  }

  async fetchPass () {
    this.pass = null
    this.initialized = false
    if (this.urlName) {
      this.pass = await cardService.getPassByName(this.urlName)
      this.initialized = true
    }
  }

  async mounted () {
    await this.fetchPass()
  }
}
